import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export function useMultiSelectMobileModalController(props) {
  var _React$useState = React.useState(props.value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React.useEffect(function () {
    if (!props.open) {
      setValue(props.value);
    }
  }, [props.value, props.open]);
  var handleOptionChange = React.useCallback(function (index) {
    var option = props.options[index];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = value || [];
    var isChecked = prevValue.includes(optionValue);
    if (isChecked) {
      setValue(prevValue.filter(function (v) {
        return v !== optionValue;
      }));
    } else {
      setValue([].concat(_toConsumableArray(prevValue), [optionValue]));
    }
  }, [props.options, value]);
  var handleAllOptionChange = React.useCallback(function (_, value) {
    if (value) {
      setValue(props.options.map(function (option) {
        return option.value;
      }));
    } else {
      setValue([]);
    }
  }, [props.options]);
  var allOptionLabel = React.useMemo(function () {
    if (!props.allOption) {
      return;
    }
    return typeof props.allOption === 'boolean' ? 'Выбрать всё' : props.allOption;
  }, [props.allOption]);
  return {
    value: value,
    handleOptionChange: handleOptionChange,
    handleAllOptionChange: handleAllOptionChange,
    allOptionLabel: allOptionLabel
  };
}